<template>
  <div class="pupils bg-white !important">

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div style="width: 100%; text-align: center" v-if="loading">
        <i class="spinner fa fa-spinner fa-spin"></i>
      </div>

      <section v-else>
        <div class="flex justify-between w-11/12 mb-1">
          <div class="relative grow ml-3 mb-3 ">
                    <div
                      class="
                        flex
                        absolute
                        inset-y-0
                        left-0
                        items-center
                        pl-3
                        pointer-events-none
                      "
                    >
                      <svg
                        class="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                      </svg>
                    </div>
                    <input
                      type="search"
                      class="
                        h-full
                        text-gray-700
                        placeholder-gray-500
                        w-full
                        bg-gray-100
                        rounded
                        shadow-sm
                        p-1
                        pl-10
                        m-1
                      "
                      name="search"
                      v-model="search"
                      placeholder="Search pupils"
                    />
                  </div>

          <dropdown :options="classDropdown" :selected="filteredClass" v-on:updateOption="updateFilteredClass" class="w-56 bg-gray-200  text-center"
               v-bind:class="filteredClass.id > 0 ? 'text-gray-700 ' : ''" >
          ></dropdown>
          
        </div>
        
        <table v-if="componentLoaded" class="table-wrapper w-95p mx-auto mb-24">
          <thead>
            <tr class="bg-gray-200 text-xs">
              <th colspan="2" class="pl-3 py-2 text-left border w-6/12">
                Pupil
              </th>
              <th class="pl-2 py-2 border w-4/12 text-left">Class</th>
              <th class="pl-2 py-2 border">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="pupil in filteredList"
              :key="pupil.identifier"
              @click="selectPupil(pupil)"
              class="
                group
                w-full
                mx-auto
                p-3
                cursor-pointer
                hover:opacity-50
              "
            >
              <td colspan="2" class="border-l border-r text-xs w-6/12">
                <div class="flex content-center pl-1">
                  <div
                    class="
                      w-8
                      h-8
                      rounded-full
                      text-center
                      bg-blue-100
                      bg-opacity-75
                      pt-1
                      mr-3
                    "
                  >
                    {{ getPupilInitials(pupil) }}
                  </div>

                  <span class="mt-1">{{ pupil.name }}</span>
                  
                </div>
              </td>
              <td class="w-4/12 border-r text-xs">{{ pupil.inclass }}</td>
              <td class="text-center text-lg">
                <i
                  v-bind:class="[
                    inSelected(pupil)
                      ? 'fas fa-check-circle text-green-400'
                      : ' far fa-circle text-gray-300',
                  ]"
                ></i>

              </td>
            </tr>
          </tbody>
        </table>

        <p class="m-5 mx-12" v-else>
          We could not find any data for your given selection.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pupilMixin } from "@/mixins/pupilMixin.js";

const dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "pupils",
  mixins: [pupilMixin],
  props: {
    selectedPupils: { type: Array, required: false },
    allowMultiple: { type: Boolean, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.filteredList.length > 0;
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    classDropdown() {
      var results = [{ id: 0, name: "Showing All Classes" }].concat(this.classesArray);
      this.filteredClass = results[0];
      return results;
    },
    orderedPupils() {
      var vm = this;
      var classChosen = vm.filteredClass;

      let results = vm.filterPupils([], [], classChosen);
      return _.orderBy(results, ["name", "class", "name"]);
    },
    filteredList() {
      return this.orderedPupils.filter((item) => {
        var vm = this;
        return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });
    },
  },
  data() {
    return {
      search: "",
      filteredClass: {},
      loading: false,
      errored: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    setSearch() {
      this.showSearch = !this.showSearch;
      this.search = "";
    },
    updateFilteredClass(value) {
      this.filteredClass = value;
    },
    getPupilInitials(pupil) {
      return pupil.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3);
    },
    inSelected(pupil) {
      let found = this.selectedPupils.find(
        (l) => l.identifier === pupil.identifier
      );
      return found;
    },
    selectPupil(pupil) {
      this.$emit("pupil-selected", pupil);
    },
  },
  components: {
    dropdown,
  },
};
</script>


<style scoped>

  .table-wrapper td {
			padding: 0.6em !important;
		}

</style>